import { Component } from 'react';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { isMobileOnly, isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import loadable from '@utils/loadable';

import dataNewsSources from '../../data/dataNewSources';

import ButtonComponent from '../Buttons/ButtonComponent';

import withComponentName from '../../decorators/withComponentName';

import Styles from './styles.module.scss';

const CustomCarousel = loadable(() => import('../CustomCarousel'));
const AnimatedCircleComponent = loadable(() => import('../AnimatedCircleComponent'));
const CorporateSection = loadable(() => import('./EnterpriseSolutionsComponents/CorporateSection'));
const CorporateClientCloud = loadable(() => import('./EnterpriseSolutionsComponents/CorporateClientCloud'));
const CorporateFinancialContent = loadable(() => import('./EnterpriseSolutionsComponents/CorporateFinancialContent'));
const ModalWrapperComponent = loadable(() => import('../LandingPages/LearnMoreComponents/ModalWrapperComponent'));
const LanguageComponent = loadable(() => import('../LanguageComponent'));
const BackgroundNewSources = loadable(() => import('./EnterpriseSolutionsComponents/CorporatePageBackground/new_sources background'));
const BackgroundLanguage = loadable(() => import('./EnterpriseSolutionsComponents/CorporatePageBackground/language background'));
const BackgroundChatBot = loadable(() => import('./EnterpriseSolutionsComponents/CorporatePageBackground/chat_bot background'));
const CorporateHeader = loadable(() => import('./EnterpriseSolutionsComponents/CorporateHeader'));
const MobileAnchorButtons = loadable(() => import('../MobileAnchorButtons'));
const CTAbuttons = loadable(() => import('../Header/MainHeaderComponent/CTAbuttons'));
const TrustedCompaniesLogosComponent = loadable(() => import('../TrustedCompaniesLogosComponent'));

const cx = classNames.bind(Styles);
const isTablet = isMobile && !isMobileOnly;

export class MainCorporate extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      width: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandle);
    document.querySelector('a[href^="#anchor"]').addEventListener('click', this.slidePage);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandle);
    document.querySelector('a[href^="#anchor"]').removeEventListener('click', this.slidePage);

    // remove user voice dialog if was oppend from header
    const popover = document.querySelector('div.uv-popover.uv-bottom');
    if (popover !== null) {
      popover.remove();
    }
  }

  setElement(el) {
    if (el) {
      this.layoutEl = el;
      setTimeout(this.setWidth, 0);
    }
  }

  setWidth() {
    this.setState({ width: this.layoutEl.offsetWidth });
  }

  resizeHandle() {
    this.setWidth();
  }

  slidePage(e) {
    e.preventDefault();
    e.target.scrollIntoView({
      block: 'start',
      behavior: 'smooth',
    });
  }

  render() {
    const { windowWidth, isChatBot } = this.props;
    const { width } = this.state;

    const setAmount = (maxAmount, tabletAmount, modileAmount) => {
      if (windowWidth !== 0 && windowWidth < 1024 && windowWidth > 700) return tabletAmount;

      if (windowWidth >= 1024) return maxAmount;

      if (windowWidth <= 700) return modileAmount;
    };

    const trustedClassName = cx('trusted');

    return (
      <div ref={this.setElement}>
        <CorporateHeader />
        <section className={Styles.greeting_section}>
          <div className={Styles.greeting}>
            <h1 className={Styles.title}>
              <div>ENTERPRISE SOLUTIONS</div>
              <div>for</div>
              <div>FINANCIAL INSTITUTIONS and STARTUPS</div>
            </h1>
            <div className={Styles.greeting_container}>
              <div className={Styles.description}>
                <div className={Styles.blue_desc}>All Content and Noise</div>
                <div className={Styles.gray_desc}>Filtered by</div>
                <div className={Styles.blue_desc}>Segments</div>
                <div className={Styles.black_desc}>
                  Investor, Newbie to Finance, Financial Advisor, Asset Manager, Wealth Manager...
                </div>
                <div className={Styles.gray_desc}>Filtered for</div>
                <div className={Styles.blue_desc}>your clients</div>
              </div>
              <div className={Styles.description_mobile}>
                <div className={Styles.mobile_figures}>
                  <div className={Styles.figures_item}>
                    <p>1</p>
                    <div className={Styles.figures_item_dott}><div /></div>
                  </div>
                  <div className={Styles.figures_item}>
                    <p>2</p>
                    <div className={Styles.figures_item_dott}><div /></div>
                  </div>
                  <div className={Styles.figures_item}>
                    <p>3</p>
                    <div className={Styles.figures_item_dott}><div /></div>
                  </div>
                </div>
                <div className={Styles.mobile_text}>
                  <div className={Styles.blue_desc}>All Content and Noise</div>
                  <div className={Styles.gray_desc}>Filtered by</div>
                  <div className={Styles.blue_desc}>Segments</div>
                  <div className={Styles.black_desc}>
                    Investor, Newbie to Finance, Financial Advisor,
                    <br />
                    {' '}
                    Asset Manager, Wealth Manager...
                  </div>
                  <div className={Styles.gray_desc}>Filtered for</div>
                  <div className={Styles.blue_desc}>your clients</div>
                </div>
              </div>
              <div className={Styles.main_logo} />
              <div className={Styles.get_started}>
                <div className={Styles.presentation}>
                  <div className={Styles.general}>
                    <div className={Styles.line_through}>
                      <span>General</span>
                      <div className={Styles.line} />
                    </div>
                    {' '}
                    Personalised
                  </div>
                  <div className={Styles.secondary}>
                    Financial and Business News,
                    <br />
                    {' '}
                    Tweets, and Research
                  </div>
                </div>
                <div className={Styles.presentation}>
                  <div className={Styles.general}>
                    For&nbsp;
                    <div className={Styles.line_through}>
                      <span>everyone</span>
                      <div className={Styles.line} />
                    </div>
                    <div className={Styles.your_clients}>Your Clients</div>
                  </div>
                  <div className={Styles.secondary}>By Text and Voice</div>
                </div>
              </div>
            </div>
          </div>
          <div className={Styles.rewind_to_down}>
            <a href="#anchor" className={Styles.ref_down} />
          </div>
        </section>
        <div id="anchor" className={cx('anchor', { tablet: isTablet })} />

        <section className={Styles.keep_your_client}>
          <AnimatedCircleComponent
            inSection
            className={Styles.anim_circle}
          />
          <CorporateSection
            head="keep your clients engaged"
            headUpercase
            subHead="Reduce churn and increase average revenue per client"
            text="Content remains king, and most major companies including Facebook, Linkedin,
            and Twitter utilise content to keep their clients engaged. We help you do the same."
          />
        </section>

        <section className={trustedClassName}>
          <AnimatedCircleComponent
            inSection
            className={Styles.anim_circle}
          />
          <h3 className={`${Styles.title} text-uppercase`}>trusted by</h3>
          <h5 className={Styles.institutions}>
            Financial Institutions and Fintech Companies
          </h5>
          <div className={Styles.carousel_container}>
            <TrustedCompaniesLogosComponent />
          </div>
        </section>

        <section className={Styles.CityFALCON}>
          <AnimatedCircleComponent
            inSection
            className={Styles.anim_circle}
          />
          <CorporateSection
            head="CityFALCON leverages Machine Learning
            and Natural Language Processing (NLP)"
            headUpercase={false}
            btn="Learn more"
            btnLink="/nlp-nlu-machine-learning-for-financial-news-tweets-research"
          />
        </section>

        <section className={Styles.our_audiences}>
          <h3 className={`${Styles.title} text-uppercase`}>Our Audiences</h3>
          <div className={Styles.carousel_container}>
            <CustomCarousel
              width={windowWidth}
              amountInSlide={setAmount(3, 3, 1)}
              url="segments"
            />
          </div>
        </section>

        <section className={Styles.news_sources}>
          <div className={Styles.backgroundWraper}>
            <BackgroundNewSources width={width} />
          </div>
          <AnimatedCircleComponent
            inSection
            className={Styles.anim_circle}
          />
          <h3 className={`${Styles.title} text-uppercase`}>news sources</h3>
          <div className={Styles.carousel_container}>
            <CustomCarousel
              width={windowWidth}
              amountInSlide={setAmount(3, 3, 1)}
              section="news_sources"
              data={dataNewsSources}
            />
          </div>
        </section>

        <section className={Styles.news_coverage}>
          <h3 className={`${Styles.title} text-uppercase`}>news coverage</h3>
          <div className={Styles.carousel_container}>
            <CustomCarousel
              width={windowWidth}
              amountInSlide={setAmount(5, 5, 1)}
              section="news_coverage"
              url="asset_classes"
            />
          </div>
        </section>

        <section className={Styles.language}>
          {!isChatBot && (
            <div className={Styles.backgroundWraper}>
              <BackgroundLanguage width={width} />
            </div>
          )}
          <AnimatedCircleComponent
            inSection
            className={Styles.anim_circle}
          />
          <LanguageComponent />
        </section>

        {/* chatbot was hidden display: none */}

        <section className={Styles.chat_bot}>
          {isChatBot && (
          <div className={Styles.backgroundWraper}>
            <BackgroundChatBot width={width} />
          </div>
          )}
          <div className={Styles.chat_bot_description}>
            <div className={Styles.description_container}>
              <h3 className={`${Styles.title} text-uppercase`}>change the way your client interact with content</h3>
              <ButtonComponent
                path=""
                value="Open Chat Bot"
                short
              />
            </div>
          </div>
          <div className={Styles.chat_bot_image} />
        </section>

        <section className={Styles.new_to_investing}>
          <div className={Styles.face_question} />
        </section>
        <CorporateClientCloud />
        <CorporateFinancialContent />

        <section className={Styles.how_works}>
          <h1 className={`${Styles.title} text-uppercase`}>How our integrated api works</h1>
          <div className={Styles.modal_video}>
            <ModalWrapperComponent
              source="https://cityfalcon.wistia.com/medias/wijksrco2x"
            />
          </div>
          <div className={Styles.button_container}>
            <ButtonComponent
              path="/financial-news-api"
              value="Try Our API"
              green
              longer
            />
          </div>
        </section>
        <MobileAnchorButtons doubleButton>
          <CTAbuttons
            contactUsLeadsToForm
            path="/financial-enterprise-solutions"
            ctaButtonType="mobileAnchorButton"
          />
        </MobileAnchorButtons>
      </div>
    );
  }
}

const mapStateToProps = ({ common }) => ({
  windowWidth: common.width,
});

export default connect(mapStateToProps)(
  withComponentName(MainCorporate),
);
